var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.defaultOptions)?_c('lottie',{attrs:{"options":_vm.defaultOptions,"height":300,"width":300},on:{"animCreated":_vm.handleAnimation}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }